// tableQuiz
// A simple clickable quiz widget.
// This widget blocks out a table from being shown until a user clicks through and submits the forms.
// The widget will attain the value of the form fields and apply them to both forms so they match.
import $ from 'jquery';
import './style.scss';

// Condenses forEach into a function.
function each(items, callback) {
  Array.prototype.forEach.call(items, callback);
}

function showNextPanel(current, next) {
  current.classList.add('hide');
  next.classList.remove('hide');
}

function tableQuiz(selector) {
  const widgets = document.querySelectorAll(selector);

  each(widgets, (widget) => {
    const panelsMerged = widget.classList.contains('table-quiz--merged');
    const panels = widget.querySelectorAll('.js-table-quiz__panel');
    // Overal form container.
    const form = widget.querySelector('form.js-table-quiz__form');
    const otherForm = widget.querySelector('form:not(.js-table-quiz__form)');

    // on submission we want to update the original filter form
    // and trigger the filtering from there
    form.addEventListener('submit', (ev) => {
      ev.preventDefault();
      // Hides the overal form from the page.
      form.classList.add('hide');
      // Finds the form inputs.
      const fields = form.querySelectorAll('input[type="radio"]:checked, select');

      // Loops through each of the fields and finds the selected value.
      each(fields, (field) => {
        each(otherForm.querySelectorAll(`select[name="${field.name}"]`), (el) => {
          const select = el;
          // The selected value is then applied to both fields.
          select.value = field.value;

          // track the fields that were submitted
          if ($.trackEvent && form.dataset) {
            const trackLabel = field.dataset.trackLabel || field.name;
            const trackValue = field.dataset.trackValue || field.value;
            $.trackEvent(form.dataset.filter, trackLabel, trackValue);
          }
        });
      });

      // Trigger the original filter form
      otherForm.querySelector('button').click();

      widget.classList.add('table-quiz--complete');

      // Remove filter class which is applied if the modal is active (css table-quiz/style.scss)
      if (panelsMerged) {
        widget.parentNode.classList.remove('has-active-modal');
      }
    });

    // Cycles through to the next panels, shows and hides
    each(panels, (panel) => {
      const navs = panel.querySelectorAll('.js-table-quiz__panelNav');
      const inputs = panel.querySelectorAll('input');

      // Handles the basic navigation around the panels.
      each(navs, (nav) => {
        nav.addEventListener('click', (ev) => {
          ev.preventDefault();
          // Finds the href attribute and once the user clicks, it takes them to
          // the next panel with the matching attribute.
          showNextPanel(panel, document.querySelector(nav.getAttribute('href')));

          $.trackEvent('Table Quiz', 'Navigate', nav.dataset.trackValue);
        });
      });

      if (!panelsMerged) {
        // Cycles through to the next panels, shows and hides after the radios are selected.
        each(inputs, (input) => {
          input.addEventListener('change', () => {
            showNextPanel(panel, panel.nextElementSibling);
          });
        });
      }
    });
  });
}

export default tableQuiz;
